import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ae54883"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index-layout"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "main"
};
const _hoisted_4 = {
  class: "slide"
};
const _hoisted_5 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode($setup["HeaderBar"], null, {
    more: _withCtx(() => [_createVNode($setup["SvipTag"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode($setup["SlideBar"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view)])]), _createVNode($setup["FeedbackBox"], {
    class: "feedback"
  })]), _withDirectives(_createVNode($setup["InternetDisconnected"], {
    isOnline: $setup.network.isOnline
  }, null, 8, ["isOnline"]), [[_vShow, !$setup.network.isOnline]])], 64);
}